import { gql } from '@apollo/client';
const AUTOCOMPLETE_PRODUCT_VARIANT_LABELS = gql `
  query ProductVariantLabels {
    autocomplete {
      id
      productVariantLabels {
        id
        attributeType
        category
        attributeLabelPL
        attributeLabelEN
      }
    }
  }
`;
export default AUTOCOMPLETE_PRODUCT_VARIANT_LABELS;
